<template>
  <BreadCrumb PageTitle="Users" />
  <UsersSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import UsersSettings from "../../components/Settings/UsersSettings.vue";

export default defineComponent({
  name: "SettingsUsersPage",
  components: {
    BreadCrumb,
    UsersSettings,
  },
});
</script>